import Vue from 'vue'
import Vuex from 'vuex'
import api from '../http/api.js'
import { loader } from './modules/loader';
import { openClaim } from './modules/open-claim';

import createPersistedState from "vuex-persistedstate";
import { getField, updateField } from 'vuex-map-fields';

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        cs : "rtGXNyIHhQVYBDv91ASBQ8kjw7qgudzvnKOfp1un",
        status: '',
        token: window.sessionStorage.getItem('token') || '',
        refresh_token: window.sessionStorage.getItem('refresh_token') || '',
        menuIsOpen: false,
        userInfo: {},
        privacy: null,
    },
    mutations: {
        updateField, // vuex-map-fields
        auth_request(state){
          state.status = 'loading'
        },
        auth_success(state, tokens){
            state.status = 'success'
            state.token = tokens.token
            state.refresh_token = tokens.refresh_token
            //window.sessionStorage.setItem('token', tokens.token);
            //window.sessionStorage.setItem('refresh_token', tokens.refresh_token);
        },
        auth_error(state){
            state.status = 'error'
            //window.sessionStorage.removeItem('token')
            //window.sessionStorage.removeItem('refresh_token')
        },
        logout(state){
            state.status = ''
            state.token = ''
            state.refresh_token = ''
            window.sessionStorage.removeItem('token');
            window.sessionStorage.removeItem('refresh_token');
        },
        toggle_menu(state){
            state.menuIsOpen = !state.menuIsOpen
        },
        user_info(state, user){
            state.userInfo = {
                name: user.name,
                img: user.img,
                policyNumber: user.policy.code,
                effect_date: user.effect_date,
                expire_date: user.expire_date,
                email: user.email,
                phoneNumber: user.infos.phone_number
            }
        },
        privacy(state, privacy){
            state.privacy = privacy
        },
        accept_privacy(state, privacy){
            state.privacy = privacy
        },
        set_img(state, imgPath){
            state.userInfo.img = imgPath;
        },
        token_success(state, user){
            state.userInfo.name = user.name;
        },
    },
    actions: {
        login({commit, getters}, user){

            let payload = {
                grant_type: 'password',
                client_secret: getters.cs,
                client_id: 2,
                scope: '*',
                ...user
            }

            return new Promise((resolve, reject) => {
                commit('auth_request')
                api.post('/oauth/token', payload)
                    .then(resp => {
                        let token = resp.data.access_token
                        let refresh_token = resp.data.refresh_token

                        commit('auth_success', {
                            token: token,
                            refresh_token: refresh_token
                        })

                        resolve(resp);
                    })
                    .catch(err => {
                        commit('auth_error')
                        reject(err)
                    });
            }).then(function(){
                return new Promise((resolve, reject) => {
                    api.get('/v1/me')
                        .then((response) => {
                            commit('user_info', response.data.data);
                            commit('privacy', response.data.data.privacy);
                            resolve();
                        }, (error) => {
                            //console.log(error);
                            reject(error);
                        });
                });
                
            });
        },
        refreshToken({commit, getters}, token){
            // TODO - capire come esternalizzare client_secret etc
            const payload = {
                grant_type: 'refresh_token',
                client_secret: getters.cs,
                client_id: 2,
                scope: '*', 
                refresh_token: token
            }
            return new Promise((resolve, reject) => {
                commit('auth_request')
                api.post('/oauth/token', payload)
                    .then(resp => {
                        //console.log('refreshing token...', resp);
                        let token = resp.data.access_token
                        let refresh_token = resp.data.refresh_token

                        commit('auth_success', {
                            token: token,
                            refresh_token: refresh_token
                        })

                        resolve(resp)
                    })
                    .catch(err => {
                        //console.log("refreshToken catch", err);
                        //commit('auth_error')
                        //localStorage.removeItem('token')
                        //localStorage.removeItem('refresh_token')
                        reject(err)
                    })
            })
        },
        checkVerificationToken({commit}, token){
            //console.log(commit);
            return new Promise((resolve, reject) => {
                api.post('/v1/verification-token', {
                    verification_token: token
                })
                    .then(response => {
                        commit('token_success', response.data.data);
                        resolve(response)
                    })
                    .catch(err => {
                        //console.log("checkVerificationToken catch", err);
                        reject(err)
                    });
            });
        },
        logout({commit}){
            return new Promise((resolve) => {
              commit('logout')
              resolve()
            })
        },
        toggleMenu({commit}){
            //console.log("toggle.isOpen", this.state.menuIsOpen);
            const body = document.body;

            if (!this.state.menuIsOpen) {
                body.classList.add('menuopenuser');
            } else {
                body.classList.remove('menuopenuser');
            }
            commit('toggle_menu')
        },
        acceptPrivacy({commit}, privacy){

            //console.log("privacy to commit", privacy);
            //console.log("current privacy", this.state.privacy);

            return new Promise((resolve, reject) => {

                if(this.state.privacy == null){
                    commit('accept_privacy', privacy);
                } else {
                    commit('accept_privacy', { ...this.state.privacy, ...privacy});                    
                }   

                const payload = {
                    email: this.state.userInfo.email,
                    privacy: this.state.privacy
                }
                
                api.post('/v1/privacy', payload)
                    .then((resp) => {
                        resolve(resp);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        setImg({commit}, imgPath){
            commit('set_img', imgPath);
        }
    },
    getters : {
        getField, // vuex-map-fields
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        cs: state => state.cs,
        privacyAccepted: state => state.privacy != null && state.privacy.privacy_1 == 'accepted' && state.privacy.privacy_axa =='accepted',
        privacyCgaAccepted: state => state.privacy != null && state.privacy.cga == 'accepted',
        privacyClaimAccepted: state => state.privacy != null && state.privacy.privacy_2 == 'accepted' && state.privacy.privacy_axa_2 =='accepted'
    },
    modules: {
        loader, 
        openClaim
    },
    plugins: [createPersistedState()],
});

export default store;